import React, { useState } from 'react';
import { Select, Form, Button, Modal } from 'antd';
import { getProvinceList, getCityList } from './areaHelper';
import axios from '../../../utils/AxiosUtil';
import { modalHint } from '../../../components/reqAndHint'
import { useSelector } from 'react-redux'
export default function AreaForm(props) {
    const [form] = Form.useForm();
    const { Option } = Select;
    const langValue = useSelector(state => state.langList.value)
    function resetFormFields() {
        // console.log('form reset fields*');
        form.resetFields();
    }

    //验证未通过
    function onFinishFailed({ values, errorFields, outOfDate }) {
        // console.log("addArea form onFinishFailed:", values, errorFields, outOfDate);
    }

    //点击“新建”按钮（提交表单）
    function onFinish(values) {
        // console.log("addArea form onFinish:", values);

        Modal.confirm({
            title: '确定要新建吗？',
            onOk: () => {
                axios.post('/fund/area/add', values).then((data) => {
                    modalHint('success', data.data.msg, () => {
                        resetFormFields();
                        props.handleSuccess(values);
                    });
                }).catch((e) => {
                    modalHint('error', e.response.data.msg);
                });
            }
        })
    }

    //所有省名
    let provinceList = getProvinceList();

    let [cityList, setCityList] = useState([]);

    function handleProvinceChange(provinceName) {
        // console.log('handleProvinceChange:', provinceName);
        form.setFieldsValue({ "city": '' });
        setCityList(getCityList(provinceName));
    }


    return (
        <Form
            name="add-area"
            form={form}
            onFinishFailed={onFinishFailed}
            onFinish={onFinish}
            initialValues={{ areaCode: '', areaName: '' }}
        >
            <div className="area-label">{langValue==0?'地区（省）Region (province)':(langValue==1?'地区（省）':'Region (province)')}：</div>
            <Form.Item
                name="province"
                rules={[{ required: true, message: '请选择地区（省）' }]}
            >
                <Select placeholder={langValue==0?'请选择Please select':(langValue==1?'请选择':'Please select')} style={{ width: 230 }} onChange={handleProvinceChange} showSearch>
                    {provinceList.map((province, i) => {
                        return <Option value={province} key={province} >{province}</Option>
                    })}
                </Select>
            </Form.Item>
            <div className="area-label">{langValue==0?'地区（市）Region (city)':(langValue==1?'地区（市）':'Region (city)')}：</div>
            <Form.Item
                name="city"
            >
                <Select placeholder={cityList.length == 0 ? '请先选择省' : '请选择'} style={{ width: 230 }}
                    showSearch
                    disabled={cityList.length == 0}>
                    <Option value=''>（不选）</Option>
                    {cityList.map((city, i) => {
                        return <Option value={city} key={city} >{city}</Option>
                    })}
                </Select>
            </Form.Item>
            <div className="area-label">{langValue==0?'编号Number':(langValue==1?'编号':'Number')}：</div>
            <Form.Item
                name="areaCode"
                rules={[{ required: true, message: '请输入编号' }]}
            >
                <input placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')} value='' style={{ width: 230, paddingLeft: 10 }} autoComplete='off' />
            </Form.Item>
            <div className="area-label">{langValue==0?'名称Name':(langValue==1?'名称':'Name')}</div>
            <Form.Item
                name="areaName"
            >
                <input placeholder={langValue==0?'请输入Please enter':(langValue==1?'请输入':'Please enter')} value='' style={{ width: 230, paddingLeft: 10 }} autoComplete='off' />
            </Form.Item>
            <div>
                <Button type="primary" htmlType="submit" >
                    {langValue==0?'新建Create':(langValue==1?'新建':'Create')}
                </Button>
            </div>
        </Form>
    )
}
